import { PencilIcon, TrashIcon } from "@heroicons/react/24/solid"; // Import the necessary icons

function Table({ data, onEdit, onDelete }) {
  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="overflow-x-auto max-h-[600px] overflow-y-auto">
        <table className="min-w-full table-auto border-collapse">
          <thead className="bg-gray-200 text-gray-700 sticky top-0 z-10">
            <tr>
              <th className="px-6 py-3 text-left font-medium">#</th>
              <th className="px-6 py-3 text-left font-medium">
                Department Name
              </th>
              <th className="px-6 py-3 text-left font-medium">Description</th>
              <th className="px-6 py-3 text-left font-medium">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((department) => (
              <tr
                key={department.id}
                className="hover:bg-gray-100 transition duration-300"
              >
                <td className="px-6 py-4 text-sm text-gray-600">
                  {department.index}
                </td>
                <td className="px-6 py-4 text-sm text-gray-800">
                  {department.title}
                </td>
                <td className="px-6 py-4 text-sm text-gray-600">
                  {department.description}
                </td>
                <td className="px-6 py-4 flex space-x-2">
                  <button
                    onClick={() => onEdit(department)}
                    className="bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 transition"
                    aria-label="Edit Department"
                  >
                    <PencilIcon className="w-5 h-5" />
                  </button>
                  <button
                    onClick={() => onDelete(department.id)}
                    className="bg-red-600 text-white p-2 rounded-md hover:bg-red-700 transition"
                    aria-label="Delete Department"
                  >
                    <TrashIcon className="w-5 h-5" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Table;
